/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import clsx from 'clsx';
import { translate } from 'src/locales/i18next/config';
import Translations from 'src/locales/i18next/translations/translation';
import useVendorData from 'src/services/hooks/useVendorData';
import { useAppSelector } from '../../../../services/redux/app/Store';
import { KTSVG } from '../../../helpers';
import { AsideMenuItem } from './AsideMenuItem';
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub';

export function AsideMenuMain() {
  const t = translate(Translations);
  const { offerEnabled, creditUsageAllowed } = useAppSelector((state) => state.auth);
  const { vendorSharedPromotions, vendorSharedCoupons } = useAppSelector((state) => state.vendorSharedOffers);
  const { _checkField } = useVendorData();

  const campaignUnseenCount = vendorSharedPromotions?.count || 0;
  const couponUnseenCount = vendorSharedCoupons?.count || 0;
  const totalUnseenCount = campaignUnseenCount + couponUnseenCount;
  const unseenBadgeClassName = 'fs-10px p-1 text-primary bg-white';
  const discountRightBadge = totalUnseenCount > 0 ? { title: 'Yeni', variant: 'light' as const, className: unseenBadgeClassName } : undefined;

  return (
    <>
      <AsideMenuItem to="/dashboard" icon="/media/sidebar/home.svg" title="Anasayfa" fontIcon="bi-app-indicator" />
      <AsideMenuItemWithSub to="/products" title="Ürünlerim" fontIcon="bi-archive" icon="/media/sidebar/product.svg">
        <AsideMenuItem to="/products/my-products" title="Tümü" hasBullet={true} />
        <AsideMenuItem to="/products/product-operations" title="Ürün İşlemleri" hasBullet={true} />
        <AsideMenuItem to="/products/questions" title="Ürün Soruları" hasBullet={true} />
        <AsideMenuItem to="/products/evaluation" title="Ürün Değerlendirmeleri" hasBullet={true} />
        <AsideMenuItem to="/products/add-products/bulk-options" title="Marka Ekleme Talepleri" hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItem to="/inventory" title="Envanter" fontIcon="bi-archive" icon="/media/sidebar/inventories.svg" />
      <AsideMenuItemWithSub to="/orders" title="Sipariş" fontIcon="bi-archive" icon="/media/sidebar/orders.svg">
        <AsideMenuItem to="/orders/orders-management" title="Siparişler" hasBullet={true} />
        <AsideMenuItem to="/orders/cancelled" title="İptaller" hasBullet={true} />
        <AsideMenuItem to="/orders/refund" title="İadeler" hasBullet={true} />
        <AsideMenuItem to="/orders/change-requests" title="Değişim Talepleri" hasBullet={true} />
        <AsideMenuItem to="/orders/cargo" title="Kargo İşlemleri" hasBullet={true} />
        <AsideMenuItem to="/orders/questions" title="Sipariş Soruları" hasBullet={true} />
        <AsideMenuItem to="/orders/order-evaluation" title="Sipariş Değerlendirmeleri" hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to="#" title="Finans" fontIcon="bi-archive" icon="/media/sidebar/finance.svg">
        {/* <AsideMenuItem to="/finance" title="Finans Sayfam" hasBullet={true} /> */}
        <AsideMenuItem to="/finance/vesting" title="Hak Ediş" hasBullet={true} />
        <AsideMenuItem to="/finance/future-estimated-payments" title="Gelecek Tahmini Ödemeler" hasBullet={true} />
        {creditUsageAllowed && <AsideMenuItem to="/finance/early-payment-request" title="Erken Ödeme Talebi" hasBullet={true} />}
        <AsideMenuItem to="/finance/payment" title="Ödemeler" hasBullet={true} />
        {/* <AsideMenuItem to="/finance/records" title="Kayıtlar" hasBullet={true} /> */}
        <AsideMenuItem to="/finance/invoices" title="Fatura İşlemleri" hasBullet={true} />
        <AsideMenuItem to="/finance/invoice-requests" title="Fatura Talepleri" hasBullet={true} />
        <AsideMenuItem to="/finance/current" title="Cari Hesap Ekstresi" hasBullet={true} />
        <AsideMenuItem to="/finance/vendor-reconciliations" title="Dönem Mutabakatlarım" hasBullet={true} />
        <AsideMenuItem to="/finance/stopaj" title="Stopaj" hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItem to="/sponsored-products" icon="/media/sidebar/sponsored-products.svg" title="Sponsorlu Ürünler" fontIcon="bi-app-indicator" />
      <AsideMenuItemWithSub to="#" title="İndirim" fontIcon="bi-archive" icon="/media/sidebar/campaign.svg" rightBadge={discountRightBadge}>
        <AsideMenuItem to="/campaigns/list" title="İndirimler" hasBullet={true} />
        {_checkField('flashSaleVisible', true) || _checkField('flashSaleProduct', true) ? <AsideMenuItem to="/flash-products" title="Flaş Ürünler" hasBullet={true} /> : null}
        <AsideMenuItem to="/campaigns/coupons" title="Kuponlar" hasBullet={true} />
        {offerEnabled && (
          <>
            <AsideMenuItem to="/campaigns/discounts/pricing-page" title="Fiyatlandırma Sayfası" hasBullet={true} />
            <AsideMenuItem to="/campaigns/discounts/commission-offers" title="Komisyon Teklifleri" hasBullet={true} />
            <AsideMenuItem to="/campaigns/discounts/badge-offers" title="Etiket Teklifleri" hasBullet={true} />
          </>
        )}
        <AsideMenuItem
          to="/campaigns/campaign-offers"
          title="Kampanyalar"
          hasBullet={true}
          rightBadge={campaignUnseenCount > 0 ? { title: vendorSharedPromotions.display, variant: 'light', className: `${unseenBadgeClassName} rounded-pill` } : undefined}
        />
        <AsideMenuItem
          to="/campaigns/coupon-offers"
          title="Kupon Tekliflerim"
          hasBullet={true}
          rightBadge={couponUnseenCount > 0 ? { title: vendorSharedCoupons.display, variant: 'light', className: `${unseenBadgeClassName} rounded-pill` } : undefined}
        />
        {_checkField('isGroupSales', true) ? <AsideMenuItem to="/group-buy-offers" title={t(`pages.groupBuyOffers.offers.title`)} hasBullet={true} /> : null}
        {_checkField('installmentPolicyPermission', 'allowed') ? (
          <>
            <AsideMenuItem
              to="/products/installment-setup"
              title="Esnek Taksit Modeli"
              hasBullet={true}
              rightBadge={{ title: 'Yeni', variant: 'danger', className: 'fs-10px p-1' }}
            />
            <AsideMenuItem
              to="/products/assigned-installment-policies"
              title="Atanmış Taksit Kurguları"
              hasBullet={true}
              rightBadge={{ title: 'Yeni', variant: 'danger', className: 'fs-10px p-1' }}
            />
          </>
        ) : null}
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to="/reports" title="Raporlar" fontIcon="bi-app-indicator" icon="/media/sidebar/report.svg">
        <AsideMenuItem to="/reports/sales" title="Satış Raporları" hasBullet={true} />
        <AsideMenuItem to="/reports/refund" title="İade Raporları" hasBullet={true} />
        <AsideMenuItem to="/reports/cancel" title="İptal Raporları" hasBullet={true} />
        <AsideMenuItem to="/reports/delayed" title="Geciken Sipariş Raporları" hasBullet={true} />
        <AsideMenuItem to="/reports/sponsored-product" title="Sponsorlu Ürün Raporu" hasBullet={true} />
        {/* <AsideMenuItem to="/reports/campaign-reports" title="Kampanya Raporları" hasBullet={true} />
        <AsideMenuItem to="/reports/coupon-reports" title="Kupon Raporları" hasBullet={true} /> */}
      </AsideMenuItemWithSub>

      {/* <AsideMenuItem to="/showcase" icon="/media/sidebar/mall.svg" title="Mağaza Vitrin" fontIcon="bi-app-indicator" /> */}
      <AsideMenuItem to="/support" icon="/media/sidebar/support.svg" title="Destek Talepleri" fontIcon="bi-app-indicator" />
      {_checkField('biSuggestProductExist', true) ? <AsideMenuItem to="/best-selling-products" icon="/media/sidebar/click-to-sell-cursor.svg" title="Tıkla Sat" /> : null}

      <div className="menu-item">
        <a href="https://bilgimerkezi.idefix.com/" target="_blank" className="menu-link without-sub">
          <span className="menu-icon">
            <KTSVG path="/media/sidebar/support.svg" className="svg-icon-2" />
          </span>
          <i className={clsx('bi fs-3', 'bi-app-indicator')}></i>
          <span className="menu-title">idefix Bilgi Merkezi</span>
        </a>
      </div>
    </>
  );
}
